function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 500,
  cy: 500,
  r: 500,
  fill: "#d52b1e"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0l1000 560m0-560L0 560",
  fillRule: "nonzero",
  stroke: "#009b48",
  strokeWidth: 86,
  transform: "scale(1 1.78571)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M500 0v560M0 280h1000",
  fillRule: "nonzero",
  stroke: "#f0f0f0",
  strokeWidth: 86,
  transform: "scale(1 1.78571)"
});

function SvgEu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEwMDAgMTAwMCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxuczpzZXJpZj0iaHR0cDovL3d3dy5zZXJpZi5jb20vIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7Ij4KICAgIDxjaXJjbGUgY3g9IjUwMCIgY3k9IjUwMCIgcj0iNTAwIiBzdHlsZT0iZmlsbDpyZ2IoMjEzLDQzLDMwKTsiLz4KICAgIDxnPgogICAgICAgIDxnPgogICAgICAgICAgICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLDAsMCwxLjc4NTcxLDAsMCkiPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTAsMEwxMDAwLDU2ME0xMDAwLDBMMCw1NjAiIHN0eWxlPSJmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6cmdiKDAsMTU1LDcyKTtzdHJva2Utd2lkdGg6ODZweDsiLz4KICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgxLDAsMCwxLjc4NTcxLDAsMCkiPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTUwMCwwTDUwMCw1NjBNMCwyODBMMTAwMCwyODAiIHN0eWxlPSJmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6I2YwZjBmMDtzdHJva2Utd2lkdGg6ODZweDsiLz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgEu as ReactComponent };